<template>
  <div class="tabs border-t border-gray-300">
    <button
      v-for="(tab, idx) in tabs"
      :key="tab.name"
      :class="['tab-button', { active: currentTabIdx === idx }]"
      @click="currentTabIdx = idx"
    >
      {{ tab.label }}
    </button>

    <keep-alive>
      <component :is="tabs[currentTabIdx].component" class="tab"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  props: ["tabs"],
  data() {
    return {
      currentTabIdx: 0
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
</style>
